
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/biorender-alternative",
      function () {
        return require("private-next-pages/biorender-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/biorender-alternative"])
      });
    }
  